import React from 'react';
import checkPtsAction from '../../actions/checkPtsAction';

class CheckPtsModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            _id: "",
            location: "",
            lat: "",
            lng: "",
            radius: "",
            warningMsg: ""
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {
        if (typeof this.props.index == 'number' && this.props.index != null) {
            this.setState({
                _id: this.props.checkPoint[this.props.index]._id,
                location: this.props.checkPoint[this.props.index].location,
                lng: this.props.checkPoint[this.props.index].geoLocation.coordinates[0],
                lat: this.props.checkPoint[this.props.index].geoLocation.coordinates[1],
                radius: this.props.checkPoint[this.props.index].radius
            });
        }
    }

    handleChange(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let value = e.target.value;
        if (index == 0) {
            this.setState({ location: value });
        } else if (index == 1) {
            this.setState({ lng: parseFloat(value) });
        } else if (index == 2) {
            this.setState({ lat: parseFloat(value) });
        } else {
            this.setState({ radius: parseInt(value) });
        }

    }

    handleSubmit(e) {
        if (this.state.location == "" || this.state.lat == "" || this.state.lng == "") {
            return this.setState({ warningMsg: "Please fill in all the information" });
        } else if (this.state.lng < -180 || this.state.lng > 180) {
            return this.setState({ warningMsg: "Longtitude value out of bound" });
        } else if (this.state.lat < -90 || this.state.lat > 90) {
            return this.setState({ warningMsg: "Latitude value out of bound" });
        } else if (this.state.radius == "") {
            return this.setState({ warningMsg: "Please fill in radius" });
        } else {
            let checkPoint = this.props.checkPoint;
            if (typeof this.props.index == "number" && this.props.index != null) {
                
                if (checkPoint[this.props.index]._id == this.state._id) {
                    checkPoint[this.props.index].location = this.state.location;
                    checkPoint[this.props.index].geoLocation.coordinates = [this.state.lng, this.state.lat];
                    checkPoint[this.props.index].radius = this.state.radius;
                }
            } else {
                checkPoint = checkPoint.concat({
                    location: this.state.location,
                    geoLocation: {
                        type: "Point",
                        coordinates: [this.state.lng, this.state.lat]
                    },
                    radius: this.state.radius
                });
            }
            checkPtsAction.checkPoint(checkPoint);
            this.props.shouldModalClose(false);
        }
    }

    modalClose() {
        this.props.shouldModalClose(false);
    }

    renderBody() {
        let body = "";
        body = (
            <div>
                <form>
                    <label>Location:</label>
                    <input className="form-control" type="text" onChange={this.handleChange} value={this.state.location} data-index="0" />
                </form>
                <form>
                    <label>Lng:</label>
                    <input className="form-control" type="number" onChange={this.handleChange} value={this.state.lng} data-index="1" />
                </form>
                <form>
                    <label>Lat:</label>
                    <input className="form-control" type="number" onChange={this.handleChange} value={this.state.lat} data-index="2" />
                </form>
                <form>
                    <label>Radius (meter):</label>
                    <input className="form-control" type="number" onChange={this.handleChange} value={this.state.radius} data-index="3" />
                </form>
            </div>
        );

        return (body);
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        let content;

        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }}>
                    <div className="modal-header">
                        <h4 className="modal-title" >Add/Edit Location</h4>
                    </div>

                    <div className="modal-body" >
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderBody()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn btn-warning"}
                            onClick={this.handleSubmit}>
                            Add
                        </button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default CheckPtsModal;


// WEBPACK FOOTER //
// ./app/setComponents/checkPtsComponents/CheckPtsModal.js